import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import ChevronLeft from "atoms/icon/icons/chevron_left.svg";

import adonisAdvisorImage from "../assets/adonis.png";
import ariaAdvisorImage from "../assets/aria.png";

import { PersonalisationAIGlossyCard } from "./PersonalisationAIGlossyCard";
import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

export interface AdvisorIdentity {
  name: "aria" | "adonis";
}

interface NiceToMeetYouAdvisorProps {
  identity: AdvisorIdentity;
  platformName: string;
  userName: string;
  delayMs?: number;
  onBack?: () => void;
  onBegin?: () => void;
}

export const NiceToMeetYouAdvisor = ({
  identity,
  platformName,
  userName,
  delayMs = 150,
  onBack,
  onBegin,
}: NiceToMeetYouAdvisorProps) => {
  const [screenState, setScreenState] = useState<"loading" | "ready">(
    "loading"
  );

  useEffect(() => {
    const id = setTimeout(() => setScreenState("ready"), delayMs);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PersonalisationScreenLayout
      disableAnimation
      header={
        <div className="flex items-center gap-2 px-3 py-4">
          <button type="button" onClick={onBack}>
            <ChevronLeft className="h-6 w-6" fill="rgb(9 31 36)" />
          </button>
        </div>
      }
      footerClassName="relative z-40 px-8 pb-8"
      footer={
        <Button style="adonisColor" size="large" onClick={onBegin} fullWidth>
          Let&apos;s begin
        </Button>
      }
      contentClassName="relative flex h-full items-center justify-center px-6 pb-8 pt-6"
    >
      {/* Dual radial gradient background */}
      <div
        className="pointer-events-none fixed inset-0"
        style={{
          top: 0,
          left: "50%",
          marginLeft: "-50%",
          background: `
            radial-gradient(circle at 30% 40%, rgba(189, 162, 128, 0.5) 0%, transparent 50%),
            radial-gradient(circle at 60% 40%, rgba(255, 235, 215, 1) 0%, transparent 50%)
          `,
        }}
      />

      <div
        className="fixed inset-0 z-30"
        style={{
          height: "70%",
          top: "30%",
          background: `linear-gradient(to bottom, transparent, #fff)
          `,
        }}
      />
      {identity.name === "aria" ? (
        <img
          className={`fixed z-10 -translate-x-1/2 transition-opacity duration-300 ease-in-out ${
            screenState === "ready" ? "opacity-100" : "opacity-0"
          }`}
          style={{
            width: "286px",
            height: "934px",
            left: "calc(50% + 22px)",
            top: "5%",
          }}
          src={ariaAdvisorImage}
          alt="Aria Advisor"
        />
      ) : (
        <img
          className={`fixed z-10 -translate-x-1/2 transition-opacity duration-300 ease-in-out ${
            screenState === "ready" ? "opacity-100" : "opacity-0"
          }`}
          style={{
            height: "978px",
            left: "calc(50% + 70px)",
            aspectRatio: "199/489",
            top: "5%",
          }}
          src={adonisAdvisorImage}
          alt="Adonis Advisor"
        />
      )}
      <div className="relative z-30 flex w-full items-center justify-center">
        <PersonalisationAIGlossyCard
          name={userName}
          platformName={platformName}
        />
      </div>
    </PersonalisationScreenLayout>
  );
};
